import React, { useContext, useEffect, useState } from 'react'
import NewButton from '../../NewComponents/NewButton'
import DateFilter from '../Account/OrdersComponents/DateFilter';

import { ReactComponent as DOWN } from "../../assets/icons/filter-down.svg";
import { ReactComponent as UP } from "../../assets/icons/filter-up.svg";
import { ReactComponent as DATE } from "../../assets/icons/Date.svg";
import { TransitionContext } from '../../Context/TransitionContext';
import { DataContext } from '../../Context/DataContext';
import { useScreenTransition } from '../../Hooks/useScreenTransition';
import { firestore } from '../../firebase.config';
import { getDiscount, getTotal } from '../../Data/Functions';
import NoData from '../../NewComponents/NoData';

const IncomeReport = ({showIncomeReport, setShowIncomeReport}) => {
    const [loading, setLoading] = useState(false);
    const { userData } = useContext(DataContext);
  
  
    const [showFilter, setShowFilter] = useState("");
  
    const [filterStartTimestamp, setFilterStartTimestamp] = useState(null);
    const [filterEndTimestamp, setFilterEndTimestamp] = useState(null);
    const [datePeriod, setDatePeriod] = useState("custom");

    const [incomeData, setIncomeData] = useState([]);
    const [totalAmountSpent, setTotalAmountSpent] = useState(0);
    const [totalAmountDue, setTotalAmountDue] = useState(0);
    const [totalNetSpent, setTotalNetSpent] = useState(0);

    const formatFilterDate = (date) => {
        return date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear();
    };

    const getDefaultTimestamps = () => {
        const date = new Date();
        const month = date.getMonth();
        const year = date.getFullYear();

        const startDateTimestamp = new Date(year, month, 1, 0, 0, 0, 0).getTime();
        const lastDateTimestamp = new Date(year, month+1, 0, 23, 59, 59, 999).getTime();

        setFilterStartTimestamp(startDateTimestamp);
        setFilterEndTimestamp(lastDateTimestamp);
    }

    useEffect(() => {
        getDefaultTimestamps();
    }, []);

    const getSelectedDateText = () => {
        if(filterStartTimestamp){
            if(filterEndTimestamp){
            return formatFilterDate(new Date(filterStartTimestamp)) +  " - "
                + formatFilterDate(new Date(filterEndTimestamp));
            }else{
            return formatFilterDate(new Date(filterStartTimestamp)) +  " - "
                + formatFilterDate(new Date());
            }

        }else{
            return "Date";
        }
    }

    const formatDate = (timestamp, showTime = false) => {
        const date = new Date(timestamp);
    
        const splitted = date.toDateString().split(" ");
    
        const time = showTime ? (' @ ' + date.toTimeString().substr(0, 5)) : "";
    
        return (
          splitted[1] +
          " " +
          splitted[2] +
          ", " +
          splitted[3] + time
        );
      };  

      const getIncomeData = async() => {
        setLoading(true);
        try{
        const ignoredEmails = await firestore.collection("incomeSheet").doc("ignoredEmails").get();
        const ignoredEmailsData = ignoredEmails.data() ? ignoredEmails.data().emails : [];

        const ordersSnap = await firestore.collection("orders")
        .where("timestamp", ">=", filterStartTimestamp)
        .where("timestamp", "<=", filterEndTimestamp).where("status", "!=", "created")
        .get();

        const filteredOrders = ordersSnap.docs.filter(doc => doc.data().status !== "cancelled" || doc.data().status !== "created");

        const orders = {};
        filteredOrders.forEach((doc) => {
            const data = doc.data();
            if (data.status === "cancelled" || (ignoredEmailsData.length > 0 && ignoredEmailsData.find(email => data.email.includes(email)))) {
                console.log(data.email);
                return;
            }
            if (orders[data.email]) {
                // If user already exists, append to existing array
                orders[data.email].push(data);
            } else {
                // If user doesn't exist, create new array with this data
                orders[data.email] = [data];
            }
        });

        const sortedData = [];

        for (const email in orders) {
            const userOrders = orders[email];
            const dueOrders = userOrders.filter(o => o.paypalOrderID === "pay-later" || o.paypalOrderID === "auto-billing" || o.paypalOrderID === "overdue");
            const amountDue = dueOrders.reduce((acc, order) => {
                const total = getTotal(order) - getDiscount(order);
                return acc + total;
            }, 0);
            const amountSpent = userOrders.reduce((acc, order) => {
                const total = getTotal(order) - getDiscount(order);
                return acc + total;
            }, 0);

            sortedData.push({email, name: userOrders[0].name, ordersCount: userOrders.length, amountSpent: amountSpent, amountDue: amountDue, netSpent: (amountSpent - amountDue), teamId: userOrders[0].teamId});
        }

        const fullData = sortedData.map(async user => {
            const teamData = await firestore.collection("teams").doc(user.teamId || "No teamId").get();
            const teamName = teamData.data()?.name || "-"
            return {email: user.email, name: user.name, ordersCount: user.ordersCount, amountSpent: user.amountSpent, amountDue: user.amountDue, netSpent: user.netSpent, teamName: teamName};
        });

        const resolvedData = await Promise.all(fullData);

        const incomeResults = resolvedData.map(user => {
            return {name: user.name, email: user.email, teamName: user.teamName, ordersCount: user.ordersCount, amountSpent: user.amountSpent.toFixed(2), amountDue: user.amountDue.toFixed(2), netSpent: user.netSpent.toFixed(2)};
        });

        const totalAmountSpent = resolvedData.reduce((acc, user) => acc + user.amountSpent, 0).toFixed(2);
        const totalAmountDue = resolvedData.reduce((acc, user) => acc + user.amountDue, 0).toFixed(2);
        const totalNetSpent = resolvedData.reduce((acc, user) => acc + user.netSpent, 0).toFixed(2);

        setIncomeData(incomeResults);
        setTotalAmountSpent(totalAmountSpent);
        setTotalAmountDue(totalAmountDue);
        setTotalNetSpent(totalNetSpent);
        setLoading(false);
        }catch(error){
            console.log(error);
            setLoading(false);
        }
      }

      console.log(incomeData);
      useEffect(() => {
        filterStartTimestamp && filterEndTimestamp && userData && getIncomeData();
      }, [filterStartTimestamp, filterEndTimestamp, userData]);


      const TableDataComponent = () => {
        return (
            <tbody>
                {incomeData.sort((a,b) => a.name.localeCompare(b.name)).concat({name: "", email: "", teamName: "", ordersCount: "Total", amountSpent: totalAmountSpent, amountDue: totalAmountDue, netSpent: totalNetSpent}).map((data,i) => 
                <tr key={data.email} className={i === incomeData.length ? " [&>td>p]:font-bold" : ""}>
                <td>
                    <p className="accountDetailsText">{i===incomeData.length ? "" : i + 1}</p>
                </td>
                <td>
                    <p className="accountDetailsText">
                        {data.name}
                    </p>
                </td>
                <td>
                    <p className="accountDetailsText">
                        {data.email}
                    </p>
                </td>
                <td>
                    <p className="accountDetailsText">
                        {data.teamName}
                    </p>
                </td>
                <td>
                    <p className="accountDetailsText w-full text-center">
                        {data.ordersCount}
                    </p>
                </td>
                <td>
                    <p className="accountDetailsText w-full text-center text-[#8080FF]">
                        ${data.amountSpent}
                    </p>
                </td>
                <td>
                    <p className="accountDetailsText w-full text-center text-red-500">
                        ${data.amountDue}
                    </p>
                </td>
                <td>
                    <p className="accountDetailsText w-full text-center text-green-500">
                        ${data.netSpent}
                    </p>
                </td>
                </tr>)
            }
            </tbody>
        )
    }

  return (
    <>
        <div className="accountMainTitleRow px-5 pt-5">
          <h2 className="accountMainTitle">Income Report</h2>
          
          <div className="flex gap-2">
            <NewButton text={"Show Dashboard"} onClick={() => {setShowIncomeReport(false)}} icon={false} />
          </div>
        </div>

        <div className="accountDetailsFiltersWrap m-0 px-4 w-full">
          <div className="relative sm:w-fit w-full">
            <div
              className="accountDetailsFilter"
              style={{
                borderColor:
                  showFilter === "date" ||
                    filterStartTimestamp ||
                    filterEndTimestamp
                    ? "#12ABBF"
                    : "#E6E7E9",
              }}
              onClick={(e) => {
                setShowFilter((f) => (f === "date" ? "" : "date"));
              }}
            >
              <DATE />
              <p className="accountDetailsFilterText">
                {getSelectedDateText()}
              </p>
              {showFilter === "date" ? <UP /> : <DOWN />}
            </div>
            {showFilter === "date" && (
              <DateFilter
                setShowModal={setShowFilter}
                startTimestamp={filterStartTimestamp}
                setStartTimestamp={setFilterStartTimestamp}
                endTimestamp={filterEndTimestamp}
                setEndTimestamp={setFilterEndTimestamp}
                period={datePeriod}
                setPeriod={setDatePeriod}
                onMouseLeave={() => setShowFilter("")}
              />
            )}
          </div>

          {/* <div style={{position: "relative"}}>
            <div className="accountDetailsFilter" style={{borderColor: (showFilter === "payment" || paymentFilter.length > 0) ? "#12ABBF" : "#E6E7E9"}} onClick={(e) => {setShowFilter(f => f === "payment" ? "" : "payment")}}>
              <STATUS/>
              <p className="accountDetailsFilterText">Status {paymentFilter !== "" ? ` (${paymentFilter})` : "" }</p>
              {showFilter === "payment" ? <UP/> : <DOWN/>}
            </div>
            {showFilter === "payment" && <SearchFilter type="payment" setStatusFilter={setPaymentFilter} selectedFilters={paymentFilter} setShowModal={setShowFilter}/>}
          </div> */}
        </div>

       { !loading && <div className="flex gap-6 px-4 justify-end align-center w-full">
            <p className="accountDetailsText bg-[#F0F0F0] text-[#8080FF] p-2 rounded-lg font-medium">Total Amount Spent: <span className="accountDetailsTextValue">${totalAmountSpent}</span></p>
            <p className="accountDetailsText bg-[#F0F0F0] text-red-500 p-2 rounded-lg font-medium">Total Amount Due: <span className="accountDetailsTextValue">${totalAmountDue}</span></p>
            <p className="accountDetailsText bg-[#F0F0F0] text-green-500 p-2 rounded-lg font-medium">Total Net Spent: <span className="accountDetailsTextValue">${totalNetSpent}</span></p>
        </div>}

        <div className="accountDetailsScroll w-full h-[calc(100vh-250px)] ">
        {loading ? <NoData loadingText={"Report"} loading={true} showBtn={false} type="order"/> :
        incomeData.length === 0 ? <NoData type="order" text={"Please select different time period"} title={"No Report Found"} showBtn={false}/>  :
            <table className="accountDetailsTable" style={{display: loading ? "none" : "table"}}>
            <thead>
                  <tr>
                    <th></th>
                    
                    <th>
                      <div className="accountData">
                        <p className="accountDetailsHeading font-bold text-gray-500">User Name</p>
                      </div>
                    </th>
                    <th>
                      <div className="accountData">
                        <p className="accountDetailsHeading font-bold text-gray-500">User Email</p>
                      </div>
                    </th>
                    <th>
                      <div className="accountData">
                        <p className="accountDetailsHeading font-bold text-gray-500">Team Name</p>
                      </div>
                    </th>
                    <th>
                      <div className="accountData justify-center">
                        <p className="accountDetailsHeading font-bold text-gray-500">Orders Count</p>
                      </div>
                    </th>
                    <th>
                      <div className="accountData justify-center">
                        <p className="accountDetailsHeading text-[#8080FF] font-bold">Amount Spend</p>
                      </div>
                    </th>
                    <th>
                      <div className="accountData justify-center">
                        <p className="accountDetailsHeading text-red-500 font-bold">Amount Due</p>
                      </div>
                    </th>
                    <th>
                      <div className="accountData justify-center">
                        <p className="accountDetailsHeading text-green-500 font-bold">Net Spent</p>
                      </div>
                    </th>
                  </tr>
                </thead>

                <TableDataComponent />

            </table>
        }
        </div>
    </>
  )
}

export default IncomeReport